import { render, staticRenderFns } from "./IpBundleEdit.vue?vue&type=template&id=62f713a0&"
import script from "./IpBundleEdit.vue?vue&type=script&lang=js&"
export * from "./IpBundleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports